import DropdownMultipleSelector from "./multiple-selector";
import DropdownSingleSelector from "./single-selector";

const DropdownSurveyInput = (props) => {
  const { selection } = props;

  const renderSelector = () => {
    switch (selection) {
      case "multiple":
        return <DropdownMultipleSelector {...props} />;
      case "single":
      default:
        return <DropdownSingleSelector {...props} />;
    }
  };

  return <div className="dropdown form-group">{renderSelector()}</div>;
};

export default DropdownSurveyInput;
